import { TemplateField } from './template-field';

export class Template {
  idSerie: number;
  idTipoPlantilla: number;
  // 🥑🥑 SRR 13/01/2021 nuevo parametro para plantillas docout
  isDocout: number;
  tipoPlantilla: string;
  descripcionPlantilla: string;
  tipoServicio: string;
  idServicio: number;
  idPlantilla: number;
  campos: TemplateField[];

  constructor() { }

  static toModel(json: string): Template {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }
    const toReturn = new Template();
    toReturn.idSerie = data.ID_SERIE;
    toReturn.idTipoPlantilla = data.ID_TIPO_PLANTILLA;
    toReturn.isDocout = data.IS_DOCOUT;
    toReturn.tipoPlantilla = data.TIPO_PLANTILLA;
    toReturn.descripcionPlantilla = data.DESC_PLANTILLA;
    toReturn.tipoServicio = data.TIPO_SERVICIO;
    toReturn.idServicio = data.ID_SERVICIO;
    toReturn.idPlantilla = data.ID_PLANTILLA;
    if (data.Campos) {
      toReturn.campos = data.Campos.map((field: TemplateField) => TemplateField.toModel(JSON.stringify(field)));
    }

    return toReturn;
  }
}
